import { Grid, Link, List, ListItemText, Typography } from '@material-ui/core';
import React from 'react';
import bounty from '../assets/midnight-draw/bounty-animations.gif';
import cowboy from '../assets/midnight-draw/cowboy-animations.gif';
import crow from '../assets/midnight-draw/crow-animations.gif';
import mockup from '../assets/midnight-draw/mockup.png';
import robot from '../assets/midnight-draw/robot-animations.gif';
import Project from '../components/Project';

const MidnightDraw = () => {
    const list = [
        `While it's dark, players can’t see each others characters;`,
        `When a thunder comes, every character is revealed under the lightning;`,
        `When a player shoot, his character reveals it’s position by the shot’s muzzle flash;`,
        `The core game mechanic is done, but there’s a lot of level design and art to finish;`,
    ];

    return (
        <Project>
            <Grid container justifyContent='center' item xs={12}>
                <img
                    src={mockup}
                    className='responsive'
                    alt='Midnight Draw Mockup'
                />
            </Grid>
            <Grid item xs={12}>
                <Typography variant='h1' component='h1'>
                    Midnight Draw
                </Typography>
                <Typography variant='overline' display='block'>
                    4-Player Cyberpunk Western Shootout chaos in the Darkness
                </Typography>
                <br />
                <Typography gutterBottom>
                    Midnight Draw is an improved version of{' '}
                    <Link href='https://diegomachado.itch.io/darkness-flashes'>
                        Darkness! Flashes!
                    </Link>{' '}
                    , game I've made for the{' '}
                    <Link href='https://twitter.com/agbicjam'>AGBIC 2015</Link>{' '}
                    Jam.
                </Typography>
                <br />
                <Typography>
                    <strong>
                        I'm the solo developer, so I'm responsible for
                        everything:
                    </strong>
                </Typography>
                <List>
                    <ListItemText>&bull; Game and Level Design;</ListItemText>
                    <ListItemText>
                        &bull; Development using{' '}
                        <Link href='https://godotengine.org/'>
                            Godot Engine
                        </Link>
                        ;
                    </ListItemText>
                    <ListItemText>
                        &bull; Art, Sprites and Animations using{' '}
                        <Link href='https://www.aseprite.org/'>Aseprite</Link>;
                    </ListItemText>
                </List>
                <br />
                <Typography>
                    <strong>Gameplay:</strong>
                </Typography>
                <List>
                    {list.map((t, i) => (
                        <ListItemText key={`task-${i}`}>
                            &bull; {t}
                        </ListItemText>
                    ))}
                </List>
            </Grid>

            <Grid
                container
                direction='row'
                justifyContent='center'
                alignItems='center'
                spacing={1}
                item
                xs={12}
            >
                <Grid item>
                    <img src={cowboy} alt='Cowboy Animations' className='gif' />
                </Grid>
                <Grid item>
                    <img src={crow} alt='Crow Animations' className='gif' />
                </Grid>
                <Grid item>
                    <img src={bounty} alt='Bounty Animations' className='gif' />
                </Grid>
                <Grid item>
                    <img src={robot} alt='Robot Animations' />
                </Grid>
            </Grid>
        </Project>
    );
};

export default MidnightDraw;
